import cn from 'classnames';

import * as styles from './styles.css';

interface IProps {
  className?: string;
  fillingPercentage?: number;
}

export function ProgressBar({ className, fillingPercentage }: IProps) {
  const fillWidth = Number(fillingPercentage) ? `${fillingPercentage}%` : 0;

  return (
    <div className={cn(styles['bar'], className)}>
      <div className={styles['bar-filler']} style={{ width: fillWidth }} />
    </div>
  );
}
